import request from "@/utils/request";

// 账号与权限

// 查询账户列表
export const getEmployee = params => {
	return request({
		url: "/employee",
		method: "GET",
		params,
	});
};

// 查询角色列表
export const getRole = params => {
	return request({
		url: "/role",
		method: "GET",
		params,
	});
};

// 创建账户
export const setEmployee = data => {
	return request({
		url: "/employee",
		method: "POST",
		data,
	});
};

// 绑定账户与角色
export const bindEmployeeRole = data => {
	return request({
		url: "/employee/role",
		method: "POST",
		data,
	});
};

// 删除账户
export const removeEmployee = params => {
	return request({
		url: "/employee",
		method: "DELETE",
		params,
	});
};
